<template>
  <div>
    <BasePopup v-model="isPopupOpen" :customClass="computedClasses">
      <div class="popup-header">
        <h3 class="title">담긴 상품 불러오기</h3>
        <button type="button" class="btn-cancel" @click="handleClose()"></button>
      </div>
      <div class="popup-body">
        <div class="contents-title-wrap mb15">
          <div class="contents-title">
            <HconCheckBox type="checkTitle" label="상품 선택" 
              :checked="productList.length > 0 && selectedIds.length === productList.length"
              @change="isAllChecked"
              :num="seletedCount" 
              name="allCheckBtn" labelClass="top-check-title" :hide-label="false" />
          </div>
          <div class="rgt-area">
            <span class="total text-gray">총 <em class="count-num">{{ productList.length }}</em>건</span>
            <span class="text-gray02">(최대 <span class="count-num">50</span>건)</span>
          </div>
        </div>
        <div class="scroll">
          <table class="tbl-type top-no-border">
            <colgroup>
              <col style="width: 10%"/>
              <col/>
              <col style="width: 12%"/>
            </colgroup>
            <thead>
              <tr class="sticky top">
                <th class="small">선택</th>
                <th class="small">상품정보</th>
                <th class="small">삭제</th>
              </tr>
            </thead>
            <tbody v-if="productList.length > 0">
              <ClientOnly>
                <tr v-for="(item, index) in productList" :key="item.id"
                  v-memo="[selectedIds.includes(item.id)]">
                  <td class="form">
                    <div class="chk-wrap hide-label">
                      <input type="checkbox" class="chk-hidden" :id="'item-' + item.id" 
                        :checked="selectedIds.includes(item.id)" 
                        @change="(e) => handleSingleCheck((e.target as HTMLInputElement).checked, item.id)"
                        name="checkTable" 
                        :spanShowLabel="true" :spanA11yLabel="true" :label="``" :hide-label="true" />
                      <label :for="'item-' + item.id" class="inp-check"></label>
                  </div>
                  </td>
                  <td class="medium left pl0">
                    <div :class="['product-item-box', {'sold-out': item.status === 'soldout'}, {'temp-sold-out': item.status === 'tempSoldout'}, {'not-available': item.status === 'notAvailable'}, {'sales-end': item.status === 'salesEnd'}, {'exh-discont': item.status === 'exhDiscont'}]">
                      <div class="thumbnail">
                        <img class="thumb-img" :src="item.src" width="80" height="80" :alt="item.alt">
                      </div>
                      <div class="product-info-box">
                        <p class="brand-name">{{ item.brandName }}</p>
                        <p class="product-name">{{ item.productName }}</p>
                        <ul class="amount-box li-bar">
                          <li>
                            <span class="percent">{{ HconCommonUtils.format.expCommaDecimal(item.productPercent) }}%</span>
                            <span class="discount ml8">{{ HconCommonUtils.format.addWon(item.discountCharge) }}</span>
                            <span class="total ml8">{{ HconCommonUtils.format.addWon(item.total) }}</span>
                          </li>
                          <li>
                            <span class="limit-period">유효기간 {{ item.limitPeriod }}일</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </td>
                  <td class="medium"><button type="button" @click="handleSelectedDelete(item.id)" class="btn btn-outline-gray xs">삭제</button></td>
                </tr>
              </ClientOnly>
            </tbody>
            <tbody v-else>
              <tr>
                <td colspan="3" class="nodata"></td>
              </tr>
            </tbody>
          </table>
        </div>
        <Transition name="fade" @after-leave="onTransitionEnd">
          <div v-if="isVisabled" class="alert-msg">
            <p>
              일부 상품은 <em>품절 또는 구매 제한으로 견적서 상품 등록이 불가</em>합니다.<br />
              해당 상품을 제외 후 진행해 주세요.
            </p>
            <button type="button" class="btn-delete01" @click="closeAlert"></button>
          </div>
        </Transition>
        <div class="button-box mt20 jc-l">
          <button type="button" @click="handleSelectedAllDelete" class="btn btn-outline">선택 삭제</button>
        </div>
      </div>
      <div class="popup-footer jc-c">
        <div class="button-box" v-if="props.flag">
          <button type="button" @click="handleSelectedAdd" class="btn lg">선택 등록</button>
        </div>
      </div>
    </BasePopup>
  </div>
</template>
<script lang="ts" setup>
import BasePopup from '@/components/com/HconComBasePopup.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'

import { ref } from 'vue'
import { ESTIMATE_CODE } from "@/constants/hconMessageConstants"
import type { QuotationAddResDto } from '~/types/estimate/backend-dto-types'

//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

const { showAlert, showConfirm } = usePopup() // 팝업 준비
const fetchBuilder  = useHconFetchBuilder()
const isPopupOpen = ref(false) // 팝업
const selectedIds = ref<(number | string)[]>([]) // 체크 대상
const isVisabled = ref(false) // 품절알림
let timer: ReturnType<typeof setTimeout> | null = null

const props = defineProps<{flag? : boolean}>()
const handleOpen = () => {
  isPopupOpen.value = true
  getAddedGdsImprList()
}

const handleClose = () => {
  isPopupOpen.value = false
  selectedIds.value = []
  selectedProList.value = []
  closeAlert();
}

const closeAlert = () => {
  isVisabled.value = false
  computedClasses.value = basicClass.value + ' temp-list1'
  if (timer) clearTimeout(timer)
}

// 품절 알림
const openAlert = () => {
  isVisabled.value = true
  timer = setTimeout(() => {
    isVisabled.value = false
  }, 3000)
}

// 리스트 클래스 제어
const basicClass = ref('custom-popup full mx-wd720'),
      computedClasses = ref(basicClass.value + ' temp-list1');

const onTransitionEnd = () => {
  computedClasses.value = basicClass.value + ' temp-list2'
}

const onTransitionEnd_chkSoldout = () => {
  computedClasses.value = basicClass.value + ' temp-list1'
}

// 전체 체크
const isAllChecked = (isChecked: boolean) => {
  if(isChecked) {
    selectedIds.value = productList.value.map(item => item.id)
  } else {
    selectedIds.value = []
  }
}
  
// 단일 체크
const handleSingleCheck = (isChecked: boolean, id: number | string) => {
  if(isChecked) {
    selectedIds.value.push(id)
  } else {
    selectedIds.value = selectedIds.value.filter(selectedIds => selectedIds !== id)
  }
}

// 체크된 select 갯수
const seletedCount = computed(() => 
  selectedIds.value.length
)


//////////////////////////////////////////////
// 담긴상품 불러오기
//////////////////////////////////////////////

// 상품 데이터 타입 정의
type ProductStatus = '' | 'soldout' | 'tempSoldout' 
      | 'notAvailable' | 'salesEnd' | 'exhDiscont' // 판매 상태: 일반, 품절, 일시품절, 판매중지, 판매종료, 전시중단

interface Product {
  id: number | string
  gdsCd : string
  dspGdsCd : string
  src: string
  alt: string
  brandName: string
  productName: string
  status: ProductStatus
  productPercent: number
  total: number
  discountCharge: number
  limitPeriod: number
}

// 선택 상품 리스트
const selectedProList = ref<SelectedProduct[]>([])

// 선택 상품 타입 정의
interface SelectedProduct {
  id: number | string
  gdsCd : string
  dspGdsCd : string
  src: string
  alt: string
  brandName: string
  productName: string
  productPercent: number
  total: number
  discountCharge: number
  limitPeriod: number
  isCashable: boolean
  payments: PaymentMethods
  inpCount: string | number
  isSoldOut: boolean
}

// 선택 상품안에 결제 가능 수단 타입 정의
interface PaymentMethods {
    hcoin: boolean
    pcoin: boolean
    card: boolean
    account: boolean
}

const productList = ref<Product[]>([]) // 상품 리스트 데이터

// 담긴상품 불러오기 조회
const getAddedGdsImprList = () => {
  
  // if(!isLogin.value) {
  //   addedGdsImprCnt.value = 0
  //   return
  // }

  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<QuotationAddResDto[]>>('/api/v1/order/estimate/items')
      .build()
      .execute()
      .then((res: any) => {
          if(res.resultCode != '200') {
              showAlert({
                title: '알림',
                message: res.resultMessage,
                confirmText: '확인'
              })
          } else {
            // 담긴상품 리스트
            const dataMap = res.data.map((item: QuotationAddResDto) => ({
              id: item.qttnObjGdsSeq,
              gdsCd: item.hcGdsCd,
              dspGdsCd: item.hcDspGdsCd,
              src: cu.getFileFullUrl(item.cpnTnailImgPath), 
              alt: item.hcDspGdsNm,
              brandName: item.brndNm,
              productName: item.hcDspGdsNm,
              status: item.buyPossYn === 'Y' ? '' : 'tempSoldout',
              productPercent: item.dcRt,
              total: item.nrmlSellPrc,
              discountCharge: item.realSellPrc,
              limitPeriod: item.vlidTermDcnt
            }))
            productList.value = dataMap
            selectedProList.value = [...selectedProList.value, ... res.data.map(transfromSelectProduct)]

            // 구매가능여부 체크
            const chkSoldout = productList.value.some((item) => item.status === 'tempSoldout')
            if(chkSoldout) {
              openAlert()
            }

            // 부모화면 최신화
            emit('update-gdsCnt', productList.value.length)
          }
      })
}

// 선택 상품 데이터 매핑
const transfromSelectProduct = (item: any): SelectedProduct => {
  return {
    id: item.hcDspGdsCd+"_"+item.hcGdsCd,
    gdsCd: item.hcGdsCd,
    dspGdsCd: item.hcDspGdsCd,
    src: cu.getFileFullUrl(item.cpnTnailImgPath),
    alt: item.brndNm + " " + item.hcDspGdsNm,
    brandName: item.brndNm,
    productName: item.hcDspGdsNm,
    productPercent: item.dcRt,
    total: item.nrmlSellPrc,
    discountCharge: item.realSellPrc,
    limitPeriod: item.vlidTermDcnt,
    isCashable: item.cshabGdsYn === 'Y' ? true : false, // 환금성 상품 여부
    inpCount: '1', // Default 1
    payments: {   hcoin: item.hcashPymtPossYn === 'Y' ? true : false
                , pcoin: item.mlgPymtPossYn === 'Y' ? true : false
                , card: item.crdPymtPossYn === 'Y' ? true : false
                , account: item.acntTrnsPossYn === 'Y' ? true : false },
    isSoldOut: item.buyPossYn === 'Y' ? false : true
  }
}


//////////////////////////////////////////////
// 담긴상품 선택 등록
//////////////////////////////////////////////

const emit = defineEmits(['chk-gds', 'update-gdsCnt', 'flag'])

const handleSelectedAdd = () => {

  // 1. 전체 상품 리스트에서 선택된 ID 체크
  const selectedProducts = productList.value.filter(item =>
    selectedIds.value.includes(item.id)
  )
  const selectedGdsCd = selectedProducts.map(item => String(item.dspGdsCd)+"_"+String(item.gdsCd))
  const finalToParent = selectedProList.value.filter((item) => 
    selectedGdsCd.includes(String(item.id))
  )

  // 2. 선택 객체 배열 전달
  emit('chk-gds', finalToParent)
}


//////////////////////////////////////////////
// 담긴상품 내역삭제
//////////////////////////////////////////////

// 선택 삭제
const handleSelectedDelete = (item: any) => {

  const gdsNoList: string[] = []
  gdsNoList.push(String(item))

  showConfirm({
    title: '선택 상품 삭제',
    message: ESTIMATE_CODE.ALT_HCON_9061,
    confirmText: '확인',
    onConfirm: () => {
      // 삭제 API 호출
      removeAddedGdsImpr(gdsNoList)
    }
  })
}

// 선택 상품 전체 삭제 버튼 선택 시
const handleSelectedAllDelete = () => {

  const gdsNoList: string[] = selectedIds.value.map(item => String(item))

  if(selectedIds.value.length === 0) {
    showAlert({
      title: '선택 삭제',
      message: ESTIMATE_CODE.ALT_HCON_9181,
      confirmText: '확인'
    })
    return
  }

  showConfirm({
    title: '선택 상품 삭제',
    message: ESTIMATE_CODE.ALT_HCON_9061,
    confirmText: '확인',
    onConfirm: () => {
      // 삭제 API 호출
      removeAddedGdsImpr(gdsNoList)
    }
  })
}

// 담긴상품 삭제 API
const removeAddedGdsImpr = (gdsNoList: string[]) => {

  const fetchBuilderResult = 
    fetchBuilder.delete<AjaxResult<QuotationAddResDto[]>>('/api/v1/order/estimate/items')
      .body({
        gdsNoList: gdsNoList
      })
      .build()
      .execute()
      .then((res: any) => {
          if(res.resultCode != '200') {
              showAlert({
                title: '알림',
                message: res.resultMessage,
                confirmText: '확인'
              })
          } else {

            // 성공시, 선택되지 않은 배열들로 화면 다시 그리기
            const targetList = productList.value.filter(item => {
              return !gdsNoList.includes(String(item.id))
            })

            productList.value.splice(0, productList.value.length);
            selectedIds.value.splice(0, selectedIds.value.length);
            
            if(targetList.length > 0) {
              productList.value.push(... targetList);
            }

            // 부모화면 최신화
            emit('update-gdsCnt', productList.value.length)
          }
      })
}

defineExpose({ handleOpen, handleClose, openAlert, onTransitionEnd_chkSoldout });

</script>
<style lang="scss">
  @use "@/assets/scss/pc/pin-hcon.scss" as *;
  @use "@/assets/scss/pc/order-hcon.scss" as *;
</style>